import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { filterFieldType } from '@features/filter/static/filterUtil';

import { storeSelectedCategory, storeSelectedFilterCheckboxType } from '@store/actions/FilterAction';

const FilterName = ({ type, data = [] }) => {
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const dispatch = useDispatch();

	return (
		<li
			className={`regular-14 gray_dark_01 d-flex justify-content-between ${
				selectedField?.selectedCheckboxField === type ? 'selected' : ''
			}`}
			onClick={() => {
				dispatch(storeSelectedFilterCheckboxType(type));
				dispatch(storeSelectedCategory({ filterLevel: 2, category: data }));
			}}
		>
			<span>{filterFieldType[type]['title']}</span>
			<span>
				<img src={`${process.env.PUBLIC_URL}/icons/right-arrow.svg`} alt="right" />
			</span>
		</li>
	);
};
export default FilterName;
